import { useAuthStore } from "..";
import { showErrorToast } from "../components/ToastContainer";
import IPasswordResetResponse from "../interfaces/IPasswordResetResponse";

const useRequestPasswordReset = (): (email: string) => Promise<IPasswordResetResponse> => {
    const authStore = useAuthStore();

    return async (email: string): Promise<IPasswordResetResponse> => {
        try {
            return await authStore.requestPasswordReset(email);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useRequestPasswordReset;